export const waitForImagesToLoad = (container) => {
  const images = container.querySelectorAll("img");
  const promises = [];

  images.forEach((img) => {
    if (!img.complete || img.naturalHeight === 0) {
      promises.push(
        new Promise((resolve) => {
          img.onload = img.onerror = resolve;
        })
      );
    }
  });

  return Promise.all(promises);
};
